<div *ngIf="pdfConfig" class="pdf-wrpr">
  <div>
    <div class="pdf-wrpr__header">{{ 'qr_code.PrintQRCode' | translate }}</div>
    <div class="pdf-wrpr__sub-txt">{{ 'qr_code.SelectFormat' | translate }}</div>
    <ion-list>
      <ion-radio-group [(ngModel)]="selectedTemplate" (ionChange)="onTemplateChange()">
        <ion-item *ngFor="let option of templateOptions; let i = index">
          <ion-label>{{ templateDisplayVal[i] | translate }}</ion-label>
          <ion-radio [value]="option"></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
  </div>

  <div class="pdf-wrpr__button-wrpr">
    <!-- [printDelay]="10000000000" -->
    <button
      class="pdf-wrpr__button"
      (click)="onClick()"
      [printStyle]="pdfConfig.printStyle"
      printSectionId="print-section"
      ngxPrint
    >
      {{ 'qr_code.PrintTags' | translate }}
    </button>
  </div>

  <div id="print-section" class="qr-pdf-content">
    <div class="container">
      <ng-container *ngFor="let data of bulkPdfData; let i = index">
        <div class="container-item">
          <div class="qr-container">
            <div class="header">
              <ng-container *ngIf="factoryLogoSrc">
                <div class="factory-logo-container">
                  <img class="factory-logo" [src]="factoryLogoSrc" />
                </div>
              </ng-container>
              <div class="solvei8-logo-container">
                <img class="solvei8-logo" [src]="pdfConfig.solvei8LogoSrc" />
              </div>
            </div>
            <div class="qr">
              <monorepo-qr-code-generator
                [value]="data.qrCodeValue"
                [fileNameToDownload]="fileNameToDownload"
                [width]="pdfConfig.QrLogo.width"
                [margin]="pdfConfig.QrLogo.margin"
              ></monorepo-qr-code-generator>
            </div>
            <table class="data-table">
              <ng-container *ngIf="pdfConfig.showPdfData && data.pdfData.length; else qrValue">
                <ng-container *ngFor="let pdfData of data.pdfData">
                  <tr>
                    <td>{{ pdfData.displayName | translate }}:</td>
                    <td>{{ pdfData.value }}</td>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-template #qrValue>
                <tr>
                  <td>{{ data.qrCodeValue }}</td>
                </tr>
              </ng-template>
            </table>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
